<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil 
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="EIS Contribution"
      text="Update EIS Contribution"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <span> Is Employee EIS Contribute? </span>
            <v-radio-group
              v-model="localEisContribution.is_employee_contributed"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <span> Is Employer EIS Contribute? </span>
            <v-radio-group
              v-model="localEisContribution.is_employer_contributed"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startDateDisplay')"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  outlined
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localEisContribution.start_date"
                type="month"
                no-title
                :min="companyEmployeeStartDate"
                @input="startDateMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10" 
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      eisContribution: {
        type: Object,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localEisContribution: null,
        startDateMenu: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.localEisContribution.start_date ? this.$moment(this.localEisContribution.start_date + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localEisContribution = { ...this.eisContribution }
       
        if (this.localEisContribution.start_date) { this.localEisContribution.start_date = this.localEisContribution.start_date.substring(0, 7) }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.companyEmployeeEisContributions().update(this.localEisContribution.id, this.prepareFormData())
              .then(res => {
                this.$snack({ message: res.data.status })
                this.$emit('updated')

                this.setProgressing(false)
                this.dialog = false
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          start_date: this.localEisContribution.start_date + '-01',
          is_employee_contributed: this.localEisContribution.is_employee_contributed,
          is_employer_contributed: this.localEisContribution.is_employer_contributed,
        }
      },
    },
  }
</script>

<style scoped>
.no-background-hover::before {
   background-color: transparent !important; 
}
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
